module.exports = {
	jsons: [
        // 'http://g.cdn.pengpengla.com/oauthgame/html5/20171101/uplivepcvoiceanim2.json'
        'https://g.cdn.pengpengla.com/oauthgame/html5/20171101/voice1.json'
    ],
    mergePics: [
        // 'http://g.cdn.pengpengla.com/oauthgame/html5/20171101/6696f23ec2ae25f944abf134ea8904d3.png'
        'https://g.cdn.pengpengla.com/oauthgame/html5/20171101/f33aec43cf5991e8bdedbbd2d1d45075.png'
    ]
};


// WEBPACK FOOTER //
// ./js/living/queueanim/voice.js